import { type UseMutationOptions, useMutation } from "@tanstack/react-query";
import { useParams } from "react-router";
import type { ImageBaseTypes } from "~enums/imageBaseTypes";
import type { ImageTypes } from "~enums/imageTypes";
import { useApi } from "./useApi";

type AddImage = {
  file: File;
  baseType: ImageBaseTypes;
  baseId: string;
  imageType: ImageTypes;
  onError?: Record<number, () => void>;
};

export const useAddImage = (options: UseMutationOptions<unknown, unknown, AddImage, unknown> = {}) => {
  const { sport, organizationId } = useParams();
  const request = useApi();

  if (!organizationId || !sport) {
    throw new Error(
      `OrganizationId or sport not found in route params. organizationId: ${organizationId}, sport: ${sport}`,
    );
  }

  return useMutation({
    mutationFn: ({ file, baseType, baseId, imageType, onError = {} }) =>
      request(`${sport}/o/${organizationId}/images/for/${baseType}/${baseId}/${imageType}`, {
        method: "POST",
        body: file,
        headers: {
          "Content-Type": file.type || "application/octet-stream",
        },
        onError,
      }),
    ...options,
  });
};
